export default function TotalCosts({total}) {
	return (
		<tr>
			<th colSpan={3}>Total costs (euro-cent): {(total / 10).toFixed(2).toLocaleString()}</th>
		</tr>
	);
};
